import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useFetchStocktakingsApi } from 'api/stocktaking'
import { Stocktaking, StocktakingSearchForm } from 'entities/stocktaking'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { stocktakingColumnInfoList, StocktakingTableData } from './stocktaking_table'
import { DisplaySetting, TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { NewStocktakingForm } from './stocktaking_form'
import { Flex } from 'components/shared/flex'
import { Button } from 'react-bootstrap'
import { InventoryExportSearchParams, useFetchInventoryExportApi } from 'api/inventory_export'
import moment from 'moment'
import { SelectField } from 'components/shared/input'
import { selectYears } from 'utils/util'

type Props = {
    history: H.History
}

const StocktakingsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<StocktakingSearchForm>()
    const searchForm = useForm<StocktakingSearchForm>({ ...query, ordering: '-stocktaking_created_at' })
    const api = useFetchStocktakingsApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<Stocktaking>()
    const stocktakingDisplaySetting = useDisplaySetting(stocktakingColumnInfoList(searchForm), 'Stocktaking')
    const displaySettings: DisplaySetting[] = [stocktakingDisplaySetting]
    const inventoryExportSearchForm = useForm<InventoryExportSearchParams>({
        year: moment().year(),
        month: moment().month() + 1,
    })
    const inventoryExportApi = useFetchInventoryExportApi(inventoryExportSearchForm)

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof StocktakingSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`stocktakings?${queryParams}`)
        }
    }, [searchForm.object])

    useEffectSkipFirst(() => {
        globalState.setLoading(inventoryExportApi.loading)
    }, [inventoryExportApi.loading])

    return (
        <>
            <ContentHeader
                headerTitle="棚卸し一覧"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewStocktakingForm
                            onComplete={() => {
                                api.execute()
                            }}
                        />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={
                    <Flex>
                        <div style={{ marginRight: 10, width: 120 }}>
                            <SelectField className="" form={inventoryExportSearchForm} attr="year" selectItems={selectYears()} />
                        </div>
                        <div style={{ width: 80 }}>
                            <SelectField
                                form={inventoryExportSearchForm}
                                attr="month"
                                selectItems={Array(12)
                                    .fill(0)
                                    .map((_, m) => ({ label: `${m + 1}月`, value: m + 1 }))}
                            />
                        </div>
                        <Button
                            onClick={() => {
                                inventoryExportApi.execute()
                            }}
                        >
                            在庫原価データ出力
                        </Button>
                    </Flex>
                }
                // right={<DisplaySettingModal displaySettings={displaySettings} />}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <div>総件数： {api.response.count.toLocaleString()}件</div>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={multipleCheckForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <TableRow>
                                <TableHeads displaySetting={stocktakingDisplaySetting} />
                                <TableCell th width={80}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={stocktakingDisplaySetting.getColumnLength() + 2}>
                            {api.response.results.map((stocktaking: Stocktaking) => {
                                return (
                                    <TableRow key={`stocktaking-${stocktaking.id}`}>
                                        <StocktakingTableData stocktaking={stocktaking} displaySetting={stocktakingDisplaySetting} />
                                        <TableCell width={80}>
                                            <Button
                                                variant="secondary"
                                                size={'sm'}
                                                onClick={() => {
                                                    props.history.push(`/stocktaking_items?stocktakingId=${stocktaking.id}`)
                                                }}
                                            >
                                                詳細
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="Stocktaking"
            ></SelectionFixedFooter>
        </>
    )
}

export default withRouter(StocktakingsPage)
